import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchProviderField, ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Dimension_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_DIMENSION_ID:    {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    DIMENSION_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    DIMENSION_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}


var DimensionSearchProviderBasic: ISearchProvider = {

  keyFields: {id:    'WB_DIMENSION_ID',
              id_ui: 'DIMENSION_ID',
              name:  'DIMENSION_NAME'},

  searchProviderFields: vUI_Dimension_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Dimension_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var DimensionSearchProfileByName: ISearchProfile = {
  profileId: "default",
  profileName: "Search by Id, Name",
  renderOptions: { ui5ResourceId: "DimensionSearchProfileByName" },

  profileFilter: [
    {profileFilterName: 'Id',     searchProviderFieldId: 'DIMENSION_ID',   renderOptions: { }},
    {profileFilterName: 'Name',   searchProviderFieldId: 'DIMENSION_NAME', renderOptions: { }}
  ],  // ISearchFields
  profileDisplayFields: [
    'DIMENSION_NAME','DIMENSION_ID', 'CREATED_DTTS', 'MODIFIED_DTTS'
  ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

  profileSearchProvider: DimensionSearchProviderBasic,

  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault: "",    //string;
  profileSorts: [] //ISearchSort[];
}


var DimensionSearch: ISearch = {
  searchName: "Find Dimension",
  renderOptions: { ui5ResourceId: "DimensionSearch"},
  searchProfileIdDefault: "default",
  searchProfiles: [DimensionSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("DimensionBO", "Dimension", DimensionSearch, "Dimension Search")

export {DimensionSearch}
